//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/DesignSimulation.js";
import "../DesignSimulation/DesignSimulation.Container.js";
let d=[[[0,"IsIncludedInOptimization",1,0]],[[["reference"],"AddReference",{},1,0],[["reference"],"RemoveReference",{},1,0],[["nReferences","references"],"GetReferences",{},0,0]],[]];
SPLM.DesignSimulation.Subcase = class extends SPLM.DesignSimulation.Container{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.DesignSimulation.Subcase";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.DesignSimulation.Subcase.IncludeInOptimization = Object.freeze({
    "True" : "True", "False" : "False"});

export default SPLM;